import {News} from '../resources/News';
import {SlugRenamed} from './SlugRenamed';

export class NewsSlugRenamed extends SlugRenamed<News> {}
